import React, { useState, useEffect, useContext, useRef } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../Header/auth - context';
import BeleznicaDialog from './BeleznicaDialog';
import './Beleznica.css';

const BeleznicaUnos = () => {
    const auth  = useContext(AuthContext);
    const toast = useRef(null);

    const [notes,     setNotes]     = useState([]);
    const [statusiDB, setStatusiDB] = useState([]);

    const [showAktivni,  setShowAktivni]  = useState(true);
    const [showZavrseni, setShowZavrseni] = useState(false);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [editId,     setEditId]     = useState(null);

    const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token });
    const handleErrors = r => { if (r.ok) return r.json(); throw r; };
    const call = (body) => fetch(process.env.REACT_APP_BACKEND_URL + '/beleznica/manage', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(body),
    }).then(handleErrors);

    const fetchInit = () => {
        call({ step: 'INIT' })
            .then(data => setStatusiDB(JSON.parse(data[0].JsonOutput).StatusiDB || []))
            .catch(() => {});
    };
    const fetchList = () => {
        call({ step: 'GET_LIST' })
            .then(data => setNotes(Array.isArray(data) ? data : []))
            .catch(() => {});
    };

    useEffect(() => { fetchInit(); fetchList(); }, []);

    const openNew  = () => { setEditId(null); setDialogOpen(true); };
    const openEdit = (note) => { setEditId(note.Izaberi); setDialogOpen(true); };

    const visibleNotes = notes.filter(n => {
        const done = !!n.Zavrseno;
        return (showAktivni && !done) || (showZavrseni && done);
    });

    return (
        <div className="bel-wrap">
            <Toast ref={toast} />
            <ConfirmDialog />

            <div className="bel-topbar">
                <Button label="Dodaj" icon="pi pi-plus" className="p-button-success" onClick={openNew} />
                <div className="bel-filters">
                    <div className="bel-filter-item">
                        <Checkbox inputId="fAkt" checked={showAktivni} onChange={e => setShowAktivni(e.checked)} />
                        <label htmlFor="fAkt">Aktivne</label>
                    </div>
                    <div className="bel-filter-item">
                        <Checkbox inputId="fZav" checked={showZavrseni} onChange={e => setShowZavrseni(e.checked)} />
                        <label htmlFor="fZav">Završene</label>
                    </div>
                </div>
            </div>

            <div className="bel-grid">
                {visibleNotes.length === 0 && <div className="bel-empty">Nema beleški za prikaz.</div>}
                {visibleNotes.map(n => (
                    <div key={n.Izaberi} className={`bel-note${n.Zavrseno ? ' bel-note-done' : ''}`} onClick={() => openEdit(n)}>
                        <div className="bel-note-text">{n.tekst}</div>
                        <div className="bel-note-meta">
                            {n.StatusOpis && <span className={`bel-badge${n.Zavrseno ? ' bel-badge-done' : ''}`}>{n.StatusOpis}</span>}
                            {n.alarm ? <span className="bel-note-alarm" title="Alarm"><i className="pi pi-bell" /></span> : null}
                            {n.RokDisplay && <span className="bel-note-rok"><i className="pi pi-clock" /> {n.RokDisplay}</span>}
                            {n.SlikeCount > 0 && <span className="bel-note-slike"><i className="pi pi-paperclip" /> {n.SlikeCount}</span>}
                        </div>
                        <div className="bel-note-entered">{n.DateEnteredDisplay}</div>
                    </div>
                ))}
            </div>

            <BeleznicaDialog
                visible={dialogOpen}
                editId={editId}
                statusiDB={statusiDB}
                onHide={() => setDialogOpen(false)}
                onSaved={fetchList}
                toast={toast}
            />
        </div>
    );
};

export default BeleznicaUnos;
